export default "__VITE_ASSET__DRd9dGnJ__"